import { ActionType, createAction } from "typesafe-actions";
import { Panel } from "@radarly/models/panel";

export const Action = {
  panelClosed: createAction("/panel/closed")<{ type?: Panel["type"] }>(),
  panelOpened: createAction("/panel/opened")<Panel>(),
  panelsClosed: createAction("/panels/closed")(),
};

export type Actions =
  | ActionType<typeof Action.panelClosed>
  | ActionType<typeof Action.panelOpened>
  | ActionType<typeof Action.panelsClosed>;
